export default {
    client : "Jain"
}